export const SIGN_UP_API = 'http://localhost:80/iam/oauth2/sign_up'
export const SIGN_IN_API = 'http://localhost:80/iam/oauth2/sign_in'
export const apiUrl = 'http://localhost:80/content'
export const productsApiUrl = 'http://localhost:80/marketplace'
export const publicUrl = process.env.PUBLIC_URL + '/'